/**
 * @generated SignedSource<<7e7adf916edff040b485a4e1da4cba3b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_OneClickConnect$data = {
  readonly codeInJira: {
    readonly userConfiguration: {
      readonly ownedBitbucketWorkspaces: ReadonlyArray<{
        readonly __typename: "CodeInJiraBitbucketWorkspace";
        readonly name: string;
        readonly slug: string;
        readonly uuid: string;
      } | null | undefined>;
    };
  };
  readonly " $fragmentType": "main_softwareCodePage_OneClickConnect";
};
export type main_softwareCodePage_OneClickConnect$key = {
  readonly " $data"?: main_softwareCodePage_OneClickConnect$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_OneClickConnect">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "main_softwareCodePage_OneClickConnect",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "CodeInJira",
        "kind": "LinkedField",
        "name": "codeInJira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "CodeInJiraUserConfiguration",
              "kind": "LinkedField",
              "name": "userConfiguration",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "CodeInJiraBitbucketWorkspace",
                    "kind": "LinkedField",
                    "name": "ownedBitbucketWorkspaces",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "kind": "ScalarField",
                          "name": "uuid"
                        },
                        "action": "THROW",
                        "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces.uuid"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "kind": "ScalarField",
                          "name": "slug"
                        },
                        "action": "THROW",
                        "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces.slug"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "kind": "ScalarField",
                          "name": "name"
                        },
                        "action": "THROW",
                        "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces.name"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                }
              ]
            },
            "action": "THROW",
            "path": "codeInJira.userConfiguration"
          }
        ]
      },
      "action": "THROW",
      "path": "codeInJira"
    }
  ],
  "type": "Query"
};

(node as any).hash = "d3152dc912cfe45540e066f5c8fe7b3c";

export default node;
